export default {

  // 设备渠道管理列表
  findChannelListapi: '/backstageApi/account/backstage/usercenter/channel/findChannelList',
  // 获取所有渠道设备列表
  findAllChannelListapi: '/backstageApi/account/backstage/usercenter/channel/findAllChannelList',
  // 添加渠道信息
  addChannelapi: '/backstageApi/account/backstage/usercenter/channel/addChannel',
  // 编辑渠道信息
  updateChannelapi: '/backstageApi/account/backstage/usercenter/channel/updateChannel',
  // 设备机型管理列表
  listapi: '/backstageApi/account/backstage/usercenter/mode/list',

  // 根据渠道id获取机型
  selectModeByChannelIdApi: '/backstageApi/account/backstage/usercenter/mode/selectModeByChannelId',
  // 设备机型添加
  machinesaveapi: '/backstageApi/account/backstage/usercenter/mode/save',
  // 机型编辑
  updateModeapi: '/backstageApi/account/backstage/usercenter/mode/updateMode',
  // 根据机型id查询信息
  getModelByIdApi: '/backstageApi/account/backstage/usercenter/mode/getModelById',
  // 非打印机设备列表查询
  deviceListapi: '/backstageApi/account/backstage/usercenter/device/list',
  deviceListFooterApi: '/backstageApi/account/backstage/usercenter/device/listFooter',

  // 打印机设备列表查询
  findPrintDeviceListApi: '/backstageApi/account/backstage/usercenter/device/findPrintDeviceList',
  findPrintDeviceListFooterApi: '/backstageApi/account/backstage/usercenter/device/findPrintDeviceListFooter',


  // 添加设备
  addsaveApapi: '/backstageApi/account/backstage/usercenter/device/saveAp',
  // 设备绑定管理
  devcielistDetailsapi: '/backstageApi/account/backstage/usercenter/device/listDetails',
  // 设备激活列表
  findActiveTotalNumapi: '/backstageApi/account/backstage/usercenter/staticstics/findActiveTotalNum',
  // 编辑设备
  updateApapi: '/backstageApi/account/backstage/usercenter/device/updateAp',
  // 设备数据清空
  clearApapi: '/backstageApi/account/backstage/usercenter/device/clearAp',
  // 设备解绑用户
  clearApRelationapi: '/backstageApi/account/backstage/usercenter/device/clearApRelation',
  // 录入设备
  apImportsapi: 'backstageApi/account/backstage/usercenter/device/apImports',
  // app用户列表
  babyUserapi: '/backstageApi/account/backstage/usercenter/apk/list',
  // 用户区域列表
  findUserByCountryAPI: '/backstageApi/account/backstage/usercenter/apk/findUserByCountry',
  // 用户绑定列表
  listDetailsapi: '/backstageApi/account/backstage/usercenter/apk/listDetails',
  // 设备活跃度统计
  findChannelActiveStaticsticsapi: '/backstageApi/account/backstage/usercenter/staticstics/findChannelActiveStaticstics',
  // 设备报表分布
  findProvinceMapStaticsticsapi: '/backstageApi/account/backstage/usercenter/staticstics/findProvinceMapStaticstics',
  // APP渠道列表
  queryAppChannelAllapi: '/backstageApi/account/backstage/usercenter/appChannel/queryAppChannelAll',
  // 设备活跃汇总统计
  queryDeviceActivesapi: '/backstageApi/account/backstage/usercenter/deviceActive/queryDeviceActives',
  // 区域分布汇总统计
  queryDeviceProvincesapi: '/backstageApi/account/backstage/usercenter/deviceActive/queryDeviceProvinces',
  // 查询设备授权列表
  queryAuthorizationsPageapi: '/backstageApi/account/backstage/usercenter/deviceAuth/queryAuthorizationsPage',
  // 清除授权列表数据
  delAuthorizationsapi: '/backstageApi/account/backstage/usercenter/deviceAuth/delAuthorizations',
  // 海外打印机banner
  sevaBannerImageapi: '/backstageApi/account/backstage/usercenter/bannerImage/sevaBannerImage',
  // 海外打印机banner分页查询
  querysevaBannerImagePageapi: '/backstageApi/account/backstage/usercenter/bannerImage/querysevaBannerImagePage',
  // 海外打印机banner分页查询
  editBannerImageapi: '/backstageApi/account/backstage/usercenter/bannerImage/editBannerImage',
  // app用户根据ID查询
  queryAppUserInfoByIdapi: '/backstageApi/account/backstage/usercenter/appUser/queryAppUserInfoById',
  // 根据userId获取详情
  queryAppUserInfoByIdApi: '/backstageApi/account/backstage/usercenter/apk/queryAppUserInfoById',
  // app p2p日志
  queryAppp2pLogPageapi: '/backstageApi/account/backstage/usercenter/device/queryAppp2pLogPage',
  // device p2p日志
  queryDevicep2pLogPageapi: '/backstageApi/account/backstage/usercenter/device/queryDevicep2pLogPage',
  // app图片上传记录
  queryPhotoUploadPageApi: '/backstageApi/account/backstage/PhotoUploadLog/findApkUploadLogPage',
  // 设备质检记录查询
  selectDeviceQAPageApi: '/backstageApi/account/backstage/DeviceAQ/selectDeviceAQPage',
  // 根据设备uid查询设备信息
  getDeviceUserInfo: '/backstageApi/account/backstage/usercenter/device/getDeviceUserInfo',
  // 根据机型id in查询
  selectModelListByIdsApi: '/backstageApi/account/backstage/usercenter/mode/selectModelListByIds',
  // 用户登陆日志
  selectUserLoginLogApi: '/backstageApi/account/backstage/usercenter/appUser/selectUserLoginLog',
  // 获取客户绑定的sn许可
  selectUserBindSnLicense: '/backstageApi/account/backstage/sysUserBindVirtualSn/selectUserBindSnLicense',
  // 获取授权许可日志
  selectVirtualSnCreateLog: '/backstageApi/account/backstage/usercenter/snauth/selectVirtualSnCreateLog',
  // 导出授权许可日志
  exportVirtualSnCreateLog: '/backstageApi/account/backstage/usercenter/snauth/exportSnCreateLog',
  // 邮件发送日志
  emailSendLog: '/backstageApi/account/backstage/emailSend/selectPage',
  // 根据 license_id获取 条数
  selectVirtualSnBatchCount: '/backstageApi/account/backstage/usercenter/snauth/selectVirtualSnBatchCountByLicenseId',
  // 根据modeSn查询model
  selectByModelSn: '/backstageApi/account/backstage/usercenter/mode/selectByModelSn',
  // 校验modeName是否存在
  selectByModeName: '/backstageApi/account/backstage/usercenter/mode/selectByModeName',
  // 任务
  selectTaskInfoListPage: '/backstageApi/account/backstage/taskInfo/selectListPage',
  // 相框设备解绑app用户
  deviceClearAllUser: '/backstageApi/account/backstage/usercenter/device/deviceClearAllUser',
  // 机型管理-校验SN前缀
  detectionSnPrefix: '/backstageApi/account/backstage/usercenter/mode/detectionSnPrefix',
  // 检测SN是否存在
  checkSN: '/backstageApi/account/backstage/usercenter/device/checkSN',
  // 更新sn计数器
  updateSnCountVirtualsnbatch: '/backstageApi/account/backstage/usercenter/snauth/updateSnCountVirtualsnbatch',
  // 根据前缀查询批次号
  queryBatchNoOne: '/backstageApi/account/backstage/usercenter/snauth/queryBatchNoOne',
  //
  queryGiftListPage:"/backstageApi/account/backstage/gift/queryListPage",

  giftDeleteByTaskId:"/backstageApi/account/backstage/gift/deleteByTaskId",
  // 礼物码
  getGiftCode:"/backstageApi/account/backstage/gift/getGiftCode",
  // 门铃app用户列表
  CamVigilUserApi: '/backstageApi/account/backstage/usercenter/apk/queryUserListPage',
  // 门铃通话记录
  queryP2pByUserIdListPageApi: '/backstageApi/account/backstage/usercenter/apk/queryP2pByUserIdListPage',
  // 导出礼物码
  getGiftCodeByBatchNameApi: '/backstageApi/account/backstage/gift/getGiftCodeByBatchName',
  // 设备事件
  getMonitorMsgV2Api: '/backstageApi/account/backstage/usercenter/device/monitorMsgV2',
  // 录像
  kvsGetClipApi: '/backstageApi/account/backstage/usercenter/device/kvsGetClip',
  // 更新批次备注
  updateBatchRemarkByIdApi: '/backstageApi/account/backstage/usercenter/snauth/updateBatchRemarkById',

  modifyMagicBitsApi: '/backstageApi/account/backstage/usercenter/device/modifyMagicBits',

  sendNoticeApi: '/backstageApi/account/backstage/usercenter/apk/sendNotice',
}



// WEBPACK FOOTER //
// ./src/api/baby/babyapi.js